import React, { Component } from "react";
import { Button, Modal } from "react-bootstrap";
import { faAirFreshener, faHome,  faInfoCircle, faSignOutAlt, faPlusCircle, faPrint} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";


export default class ModalContextMenu extends Component {




    render() 
    {


        var headerMenu = <Modal.Body>

            { (this.props.onHomePageRequest) ?
            <Button onClick={this.props.onHomePageRequest} className="contextoption">
                <FontAwesomeIcon
                    icon={faHome}
                    color="white"
                />
                &nbsp;
                home
            </Button>
            : <span/>
            }

            { (this.props.onAddReceiptPageRequest) ?
            <Button onClick={this.props.onAddReceiptPageRequest} className="contextoption">
                <FontAwesomeIcon
                    icon={faPlusCircle}
                    color="white"
                />
                &nbsp;
                new receipt
            </Button>
            : <span/>
            }


            { (this.props.onQuarantinePageRequest) ?
            <Button onClick={this.props.onQuarantinePageRequest} className="contextoption">
                <FontAwesomeIcon
                    icon={faAirFreshener}
                    color="white"
                />
                &nbsp;
                quarantined
            </Button>
            : <span/>
            }



            { (this.props.onPrintTagTestRequest) ?
            <Button onClick={this.props.onPrintTagTestRequest} className="contextoption">
                <FontAwesomeIcon
                    icon={faPrint}
                    color="white"
                />
                &nbsp;
                new receipt
            </Button>
            : <span/>
            }


            { (this.props.onAboutDialogRequest) ?
            <Button onClick={this.props.onAboutDialogRequest} className="contextoption">
                <FontAwesomeIcon
                    icon={faInfoCircle}
                    color="white"
                />
                &nbsp;
                about
            </Button>
            : <span/>
            }

            <Button onClick={this.props.onLogoutRequest} className="contextoption">
                <FontAwesomeIcon
                    icon={faSignOutAlt}
                    color="white"
                />
                &nbsp;
                log out
            </Button>
        </Modal.Body>


        return (
            <Modal
                id="contextmodal"
                show={this.props.show}
                onHide={this.props.onContextMenuCloseRequest}
            >

                {headerMenu}

            </Modal>
        );
    }
}
